export function formatYYYYmmdd(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0') // 월은 0부터 시작하므로 1을 더해줍니다.
  const day = String(date.getDate()).padStart(2, '0')

  const formattedDate = `${year}-${month}-${day}`

  return formattedDate
}

export function formatRelativeTime(date: Date, locale: string = 'ko-KR'): string {
  if (Number.isNaN(date.getTime()))
    return ''

  const now = Date.now()
  const diffSec = Math.round((date.getTime() - now) / 1000)
  const rtf = new Intl.RelativeTimeFormat([locale, 'en-US'], { numeric: 'auto' })

  const absSec = Math.abs(diffSec)
  if (absSec < 60)
    return rtf.format(diffSec, 'second')
  const diffMin = Math.round(diffSec / 60)
  if (Math.abs(diffMin) < 60)
    return rtf.format(diffMin, 'minute')
  const diffHour = Math.round(diffMin / 60)
  if (Math.abs(diffHour) < 24)
    return rtf.format(diffHour, 'hour')
  const diffDay = Math.round(diffHour / 24)
  if (Math.abs(diffDay) < 30)
    return rtf.format(diffDay, 'day')
  const diffMonth = Math.round(diffDay / 30)
  if (Math.abs(diffMonth) < 12)
    return rtf.format(diffMonth, 'month')
  const diffYear = Math.round(diffDay / 365)
  return rtf.format(diffYear, 'year')
}

export function formatIntlDate(
  date: Date,
  locale: string = 'ko-KR',
  options?: {
    year?: 'numeric' | '2-digit'
    month?: 'long' | 'short' | 'numeric' | '2-digit'
    day?: 'numeric' | '2-digit'
    timeZone?: string
  },
): string {
  const defaultOptions = {
    year: 'numeric' as const,
    month: 'long' as const,
    day: 'numeric' as const,
  }

  const formatOptions = { ...defaultOptions, ...options }
  if (Number.isNaN(date.getTime())) return ''

  return new Intl.DateTimeFormat([locale, 'en-US'], formatOptions).format(date)
}

const countryMap = new Map<string, Intl.DisplayNames>();
export function formatIntlCountry(country: string, locale: string = 'ko-KR'): string {

  if (countryMap.has(locale)) {
    return countryMap.get(locale)!.of(country)! as string;
  }

  const displayNames = new Intl.DisplayNames([locale, 'en-US'], { type: 'region' })
  countryMap.set(locale, displayNames)
  return displayNames.of(country)! as string;
}